import groupBy from 'lodash/groupBy'
import { useCallback, useMemo } from 'react'
import { ASSIGNEE_TYPE } from '../../../../../constants'

export const useCanvasDocPermissions = ({
  permission,
  assignees,
  currentUser,
}) => {
  const checkPermission = useCallback(
    key => permission?.split(',').includes(key) || false,
    [permission]
  )

  const isAssigneeOfStep = useCallback(
    permissionType => {
      if (!currentUser || !assignees) return false
      return assignees.some(
        a =>
          a.permission === permissionType &&
          a.assignee_code === currentUser.username
      )
    },
    [currentUser, assignees]
  )

  const assigneesMap = useMemo(
    () => ({
      creator: assignees?.find(el => el.permission === ASSIGNEE_TYPE.CREATE),
      ktatOffice: assignees?.find(
        el => el.permission === ASSIGNEE_TYPE.KTAT_OFFICE
      ),
      leaderApprover: assignees?.find(
        el => el.permission === ASSIGNEE_TYPE.LEADER_APPROVER
      ),
      leadKtatOffice: assignees?.find(
        el => el.permission === ASSIGNEE_TYPE.LEAD_KTAT_OFFICE
      ),
      formApprover: assignees?.find(
        el => el.permission === ASSIGNEE_TYPE.FORM_APPROVER
      ),
      boardOfDirector: assignees?.find(
        el => el.permission === ASSIGNEE_TYPE.BOARD_OF_DIRECTOR
      ),
      digitalSigner: assignees?.find(
        el => el.permission === ASSIGNEE_TYPE.DIGITAL_SIGNER
      ),
      releaser: assignees?.find(el => el.permission === ASSIGNEE_TYPE.RELEASER),
      departmentCoSigners: assignees?.filter(
        el => el.permission === ASSIGNEE_TYPE.DEPARTMENT_CO_SIGNER
      ),
    }),
    [assignees]
  )

  const coSigners = assigneesMap.departmentCoSigners || []

  const { [ASSIGNEE_TYPE.USER]: allUsers = [] } = useMemo(
    () => groupBy(assignees || [], 'assignee_type'),
    [assignees]
  )

  const userList = useMemo(
    () => allUsers.filter(el => el.permission !== ASSIGNEE_TYPE.CREATE),
    [allUsers]
  )

  return {
    checkPermission,
    isAssigneeOfStep,
    assigneesMap,
    coSigners,
    userList,
  }
}
